<template>
  <div class="ModalNewsMain modal-manager">
    <!-- Компонент ModalNewsMain -->

    <component
      v-if="currentModal"
      :is="getModalComponent('info')"
      :modal="currentModal"
      :key="currentModal.id"
      @closeModal="closeModal"
    />
    <v-badge
      v-if="modalCount > 0 && !currentModal"
      :content="modalCount"
      color="primary"
      overlap
    >
      <v-btn icon @click="showNext">
        <v-icon>mdi-email</v-icon>
      </v-btn>
    </v-badge>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NewsItemModal from '@/components/news/newsItemModal.vue';

/**
 * Компонент: ModalNewsMain
 * Описание:
 */
export default {
  name: 'ModalNewsMain',

  components: { NewsItemModal },

  props: {},

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      modalCount: 'news/modals/modalCount',
      currentModal: 'news/modals/currentReadNews',
    }),
  },

  watch: {},

  created() {
    this.fetchUnreadModals();
    // setInterval(() => {
    //   this.fetchUnreadModals();
    // }, 60000);
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    ...mapActions({
        fetchUnreadModals: 'news/modals/fetchAllUnReadNews',
        showNextModal: 'news/modals/showNextModal',
        closeCurrentModal: 'news/modals/closeCurrentModal',
      }
    ),
    getModalComponent(type) {
      const components = {
        info: 'newsItemModal',
      };
      return components[type] || components.default;
    },

    closeModal() {
      this.closeCurrentModal({ markAsRead: true });
    },

    showNext() {
      this.showNextModal();
    }
  },
};
</script>

<style scoped lang="scss">
.ModalNewsMain {
  /* Стили компонента */
  & .aaa{
    background: red;
  }
}
</style>
